var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBrandAzureStyleBrand = function SvgBrandAzureStyleBrand(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg_icon_BrandAzureStyleBrand__clip0_118_367289)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_BrandAzureStyleBrand__paint0_linear_118_367289)",
    d: "M8.02.753h7.093L7.749 22.572a1.13 1.13 0 0 1-1.072.77h-5.52a1.13 1.13 0 0 1-1.07-1.491l6.86-20.328A1.13 1.13 0 0 1 8.02.753"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0078D4",
    d: "M18.327 15.388H7.078a.52.52 0 0 0-.355.901l7.228 6.746c.21.197.488.306.776.306h6.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_BrandAzureStyleBrand__paint1_linear_118_367289)",
    d: "M8.02.753a1.12 1.12 0 0 0-1.075.784L.095 21.832a1.128 1.128 0 0 0 1.065 1.51h5.663a1.21 1.21 0 0 0 .93-.791l1.365-4.026 4.88 4.551c.204.17.46.263.726.265h6.346l-2.784-7.953-8.113.001L15.139.753z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_icon_BrandAzureStyleBrand__paint2_linear_118_367289)",
    d: "M17.08 1.521a1.13 1.13 0 0 0-1.07-.768H8.104a1.13 1.13 0 0 1 1.07.768l6.861 20.33a1.13 1.13 0 0 1-1.07 1.49h7.906a1.128 1.128 0 0 0 1.07-1.49z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_icon_BrandAzureStyleBrand__paint0_linear_118_367289",
    x1: 10.605,
    x2: 3.238,
    y1: 2.427,
    y2: 24.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#114A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0669BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_icon_BrandAzureStyleBrand__paint1_linear_118_367289",
    x1: 12.906,
    x2: 11.202,
    y1: 12.569,
    y2: 13.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_icon_BrandAzureStyleBrand__paint2_linear_118_367289",
    x1: 11.969,
    x2: 20.055,
    y1: 1.792,
    y2: 23.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CCBF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2892DF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "svg_icon_BrandAzureStyleBrand__clip0_118_367289"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBrandAzureStyleBrand);
export { ForwardRef as ReactComponent };